import { createSlice } from '@reduxjs/toolkit';

interface counterpartiesState {
  counterpartiesList: any;
  activePanel: '';
  counterparties: any;
}

const initialState: counterpartiesState = {
  counterpartiesList: [],
  activePanel: '',
  counterparties: [],
};

const counterparties = createSlice({
  name: 'counterparties',
  initialState,
  reducers: {
    counterpartiesListAC(state, action) {
      state.counterpartiesList = action.payload;
    },
    activePanelAC(state, action) {
      state.activePanel = action.payload;
    },
    counterpartiesAC(state, action) {
      state.counterparties = [];
      action.payload.forEach((item: any) => {
        state.counterparties.push({
          ...item,
          label: item.title,
          value: item.id,
        });
      });
    },
  },
});

export const { counterpartiesListAC, activePanelAC, counterpartiesAC } = counterparties.actions;
export default counterparties.reducer;
